import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CDXUploadedFilesList } from 'src/app/model/CDXUploadedFilesList';
import { DocWayDetailsService } from 'src/app/services/docwaydetails.service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { AppConstants } from 'src/app/shared/app.constants';
import { LaunchDarklyUtil } from 'src/app/shared/launch-darkly-util';
import { FileStatus, UploadedFilesData } from 'src/app/model/UploadedFilesData';
import { ConfirmationService } from '@fm-ui-adk/components-3/common/services';
import { UserRolesService } from 'src/app/services/user-roles.service';
import { UserRoles } from 'src/app/model/UserRoles';
import { InsuranceComponent } from '../../insurance.component';

@Component({
  standalone: false,
  selector: 'app-file-upload-insurance',
  templateUrl: './file-upload-insurance.component.html',
  styleUrl: './file-upload-insurance.component.css'
})
export class FileUploadInsuranceComponent implements OnInit {
  @ViewChild('dialog1', { read: ElementRef }) dialogRef: ElementRef;

  @Output() showUploadFiles = new EventEmitter<boolean>();
  AppConstants = AppConstants;
  display1: boolean = false;
  isLoading: boolean = false;
  cols: any[];
  currentStep;
  steps;
  rowData;
  showIssueSummary: boolean;
  showIssueSummaryPreview: boolean;
  selectedFileCount: number;
  selectFilesTouched: boolean = false;
  selectAllToSubmit: boolean = false;
  finishAndCloseClicked: boolean = false;
  cdxUploadedFilesList: CDXUploadedFilesList[] = [];
  selectedFilesArray: FileStatus[] = [];
  uploadedFilesArray: UploadedFilesData[] = [];
  uploadedFiles!: FileStatus[];
  userRoles: UserRoles;

  constructor(public fileUploadService: FileUploadService,
    private endpointsService: EndpointsService,
    private launchDarkly: LaunchDarklyUtil,
    private docWayDetailsService: DocWayDetailsService,
    private insuranceComponent: InsuranceComponent,
    private confirmationService: ConfirmationService,
    private userRolesService: UserRolesService) {
    this.fileUploadService.setFileUploadInsuranceComponent(this);
  }

  ngOnInit() {
    this.fileUploadService.disableUpload = false;
    this.fileUploadService.rejectedFiles = [];

    this.cols = [
      { field: 'filename', header: 'File' },
      { field: 'status', header: 'Submission Eligibility' },
      { field: 'issueSummary', header: 'Issue Summary' },
      { field: 'receivedDT', header: 'Upload Details' }
    ];

    this.currentStep = 'UploadFileStep';
    this.showIssueSummaryPreview = false;

    this.steps = [
      {
        url: 'UploadFileStep',
        title: 'Upload Files'
      },
      {
        url: 'ReviewFileSummaryStep',
        title: 'Review File Summary'
      }];

    // get user roles
    this.userRolesService.userRoles$.subscribe(data => {
      this.userRoles = data;
    });

    this.showDialog(1);
    this.setDisplayFlex();
  }

  showDialog(num) {
    this['display' + num] = true;
  }

  onShow() {
    this.uploadedFiles = [];
    this.selectAllToSubmit = false;
  }

  onHide() {
    this.showUploadFiles.emit(false);
    this.insuranceComponent.onHide();
  }

  showIssueSummaryPage(rowData) {
    this.rowData = rowData;
    this.showIssueSummaryPreview = true;
  }

  onSubmitSelection(event: any) {
    this.selectedFilesArray = event || [];
    this.selectFilesTouched = this.selectedFilesArray.length > 0;
    this.selectAllToSubmit = this.getEligibleFiles().length > 0 && this.selectedFilesArray.length === this.getEligibleFiles().length;
  }

  onSelectAllToSubmitChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const eligibleFiles = this.getEligibleFiles();

    this.selectAllToSubmit = checkbox.checked && eligibleFiles.length > 0;
    this.selectedFilesArray = this.selectAllToSubmit ? [...eligibleFiles] : [];
    this.selectFilesTouched = this.selectedFilesArray.length > 0;
  }

  backToUpload() {
    this.setDisplayFlex();
    this.uploadedFilesArray = [];
    this.currentStep = 'UploadFileStep';
    this.selectAllToSubmit = false;
  }

  backToReview() {
    if (this.uploadedFilesArray.length != 0)
      this.currentStep = 'ReviewFileSummaryStep';
  }

  finishAndClose() {
    //check whether files that can be submitted have been touched
    let eligibleFileCount = 0;
    for (let i = 0; i < this.uploadedFiles.length; i++) {
      if (this.uploadedFiles[i].status == "Ready to submit" || this.uploadedFiles[i].status == "Acceptable with warnings")
        eligibleFileCount++;
    }
    if (eligibleFileCount > 0 && !this.selectFilesTouched) {
      this.finishAndCloseClicked = true;
    } else {
      this.continueSubmission();
    }
  }

  getEligibleFiles(): FileStatus[] {
    return (this.uploadedFiles || []).filter(file =>
      file.status === 'Ready to submit' || file.status === 'Acceptable with warnings'
    );
  }

  setDisplayFlex() {
    let dialog: HTMLElement;
    dialog = this.dialogRef.nativeElement.getElementsByClassName('ui-dialog')[0];
    dialog.style.display = 'flex';
    dialog.style.flexDirection = 'column';

    this.fileUploadService.disableUpload = false;
  }

  continueSubmission() {
    // Check if system is in maintenance mode, if yes, route to home page
    this.launchDarkly.getLaunchDarklyShutDown(this, this.launchDarklyCallbackFileSubmission)

    // reset local values
    this.uploadedFiles = [];

    // Notify parent component file upload have completed.
    this.fileUploadService.setCompleted(true);
    this.onHide();
  }

  //when files selected for uploading
  onSelectFile(event: any) {
    // Check if system is in maintenance mode, if yes, route to home page
    this.launchDarkly.getLaunchDarklyShutDown(this, this.launchDarklyCallbackShutdown)

    //check deal id is a match to selected property
    if (!!this.insuranceComponent.selectedDusDealId) {
      this.fileUploadService.processSelectedFiles_Insurance(
        event,
        this.insuranceComponent.selectedDusDealId,
        this.insuranceComponent.selectedPropertyName,
        this.insuranceComponent.selectedColtRefNo,
        this.insuranceComponent.selectedAqsnDealId,
        this.insuranceComponent.selectedPropertyMasterNumber,
        this.insuranceComponent.selectedTransType,
        this.insuranceComponent.selectedSSN,
        this.insuranceComponent.selectedPropId,
        this.insuranceComponent.selectedCmmtNo
      );
      if (this.fileUploadService.disableUpload) {
        if (!this.fileUploadService.propertyIDMatch) {
          this.showConfirmDialog(AppConstants.FILE_NAMING_ERROR_HEADER, AppConstants.FILE_NAMING_ERROR_MSG_DEALID_MATCH, AppConstants.FILE_UPLOAD_ERROR_NOTE);
        }
        else if (!this.fileUploadService.reportTypeMatch) {
          this.showConfirmDialog(AppConstants.REPORT_TYPE_ERROR_HEADER, AppConstants.FILE_NAMING_ERROR_REPORT_TYPE_MSG, AppConstants.FILE_UPLOAD_ERROR_NOTE);
        }
        else if (!this.fileUploadService.propertyNameMatch) {
          this.showConfirmDialog(AppConstants.FILE_NAMING_ERROR_HEADER, AppConstants.FILE_PROPERTY_ERROR_MSG_MATCH, AppConstants.FILE_UPLOAD_ERROR_NOTE);
        }
        else if (!this.fileUploadService.fileTypeMatch) {
          this.showConfirmDialog(AppConstants.FILE_TYPE_ERROR_HEADER, AppConstants.FILE_TYPE_ERROR_MSG, AppConstants.FILE_UPLOAD_ERROR_NOTE);
        }
        else if (this.docWayDetailsService.mf_deal_id || this.docWayDetailsService.mf_doc_type) {
          this.showConfirmDialog(AppConstants.FILE_NAMING_ERROR_HEADER, AppConstants.FILE_NAMING_ERROR_MSG_ALL, AppConstants.FILE_UPLOAD_ERROR_NOTE);
        } 
        else if (this.fileUploadService.selectedFiles.length > AppConstants.MAX_FILE_UPLOAD_LIMIT) {
          this.showConfirmDialog(AppConstants.MAX_FILE_UPLOAD_LIMIT_HEADER, AppConstants.MAX_FILE_UPLOAD_LIMIT_MSG, "");
        } 
        else if (this.fileUploadService.selectedFileReportType == "INS") {
          this.showConfirmDialog(AppConstants.FILE_NAMING_ERROR_HEADER, AppConstants.FILE_NAMING_ERROR_MSG_DEALID, AppConstants.FILE_UPLOAD_ERROR_NOTE);        
        }
        else {
          this.showConfirmDialog(AppConstants.FILE_NAMING_ERROR_HEADER, AppConstants.FILE_NAMING_ERROR_MSG_ALL, AppConstants.FILE_UPLOAD_ERROR_NOTE);
        }
      }
    }

    //allow only 25 files per upload
    if (this.selectedFileCount > AppConstants.MAX_FILE_UPLOAD_LIMIT) {
      this.fileUploadService.disableUpload = true;
      this.showConfirmDialog(AppConstants.MAX_FILE_UPLOAD_LIMIT_HEADER, AppConstants.MAX_FILE_UPLOAD_LIMIT_MSG, "");
    }
  }


  //when 'Start Upload' is clicked
  completeFileUpload(event: any) {
    this.selectedFileCount = event.files.length;
    this.fileUploadService.selectedFiles = [];
    this.isLoading = true;
  }

  //	Callback to invoke when file upload is complete.
  onUploadFile(event: any) {
    console.log("File upload complete event:");
    console.log(event);
    // copy file to our s3 bucket when virus scan is completed and insert record in our DB
    if (event.status == "COMPLETED" || event.status == "VIRUS_FOUND" || event.status == "ERROR") {
      this.cdxUploadedFilesList.push(event);
      console.log("Virus scan completed.");
      this.insuranceComponent.processFileUpload(event);
    } else if (event.status == "REQUESTED") {
      console.log("File upload status: " + event.status);
      this.insuranceComponent.processFileUpload(event);
    }
    //confirm virus scan is completed for all files uploaded
    if (this.selectedFileCount == this.cdxUploadedFilesList.length) {
      const fileDataPromises: Promise<void>[] = [];
      for (let i = 0; i < this.cdxUploadedFilesList.length; i++) {
        fileDataPromises.push(
          this.insuranceComponent.getFilesData(this.cdxUploadedFilesList[i].fileUploadId + "___" + this.cdxUploadedFilesList[i].fileName, true)
        );
      }
      this.isLoading = false;
      this.cdxUploadedFilesList = [];
      this.uploadedFilesArray = this.insuranceComponent.uploadedFilesArray;

      Promise.all(fileDataPromises).then(() => {
        this.uploadedFiles = this.insuranceComponent.uploadedFilesArrayDisplay;
        this.currentStep = "ReviewFileSummaryStep";
      });
    }
  }

  onContinue() {
    this.currentStep = "ReviewFileSummaryStep";
  }

  showConfirmDialog(header, msg, footer) {
    let fileListString = "";
    if (this.fileUploadService.rejectedFiles) {
      for (let i = 0; i < this.fileUploadService.rejectedFiles.length; i++) {
        fileListString = fileListString + this.fileUploadService.rejectedFiles[i] + '<br>';
      }
      msg = msg + '<br><br><i>' + fileListString + '</i><br>' + footer + '<br>';
    }
    this.confirmationService.confirm({
      message: msg,
      header: header,
      accept: () => {
        this.fileUploadService.disableUpload = true;
        this.hideUpload()
      },
      key: 'confirm',
      rejectVisible: false
    });
  }

  hideUpload() {
    console.log(this.fileUploadService.disableUpload);
    this.fileUploadService.disableUpload = false;
    this.fileUploadService.rejectedFiles = [];
    this.fileUploadService.selectedFiles = [];
  }

  onSubmitFile() {
    this.isLoading = true;
    this.insuranceComponent.submittedFilesArray = [];
    for (let i = 0; i < this.selectedFilesArray.length; i++) {
      this.insuranceComponent.getFilesData(this.selectedFilesArray[i].objectKey, false);
    }
  }

  launchDarklyCallbackShutdown(systemDownFlagValue: boolean, caller) {
    caller.systemDownFlagValue = systemDownFlagValue;
    console.log('LaunchDarkly flag systemDownFlagValue = ', caller.systemDownFlagValue);
    if (Object.keys(caller.systemDownFlagValue).length > 0) {
      caller.router.navigate(['/'], { skipLocationChange: true });
    }
  }

  launchDarklyCallbackFileSubmission(systemDownFlagValue: boolean, caller) {
    caller.systemDownFlagValue = systemDownFlagValue;
    console.log('LaunchDarkly flag systemDownFlagValue = ', caller.systemDownFlagValue);
    if (Object.keys(caller.systemDownFlagValue).length > 0) {
      caller.router.navigate(['/'], { skipLocationChange: true });
    } else {
      caller.onSubmitFile();
      caller.currentStep = "UploadFileStep";
      caller.hideDialog(1);
      caller.uploadedFilesArray = [];
      caller.uploadedFilesArrayTemp = [];
      caller.uploadedFilesArrayDisplay = [];
      caller.selectedFilesArray = [];
      caller.updateTable();
    }
  }
}
